import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Footer from '../../GlobalComp/Footer/Footer';
import Classes from './ContactUs.module.css';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Home/Components/Navbar/Navbar';

export default function ContactUs() {
    const navigateTo = useNavigate();

    return (
        <>
            <div className={Classes.hero}>
                <Navbar />

                <div className={Classes.heroContent}>
                    <div className={Classes.heading}>
                        <motion.h1>Contact Us</motion.h1>
                    </div>

                    <motion.div className={Classes.formContainer}>
                        <div className={Classes.twoElem} >
                            <input type="text" className={Classes.inputField} placeholder='First Name' />
                            <input type="text" className={Classes.inputField} placeholder='Last Name' />
                        </div>
                        <input type="text" className={Classes.inputField} placeholder='Email' />
                        <textarea
                            placeholder='Message...'
                            autoCorrect={false}
                            spellCheck={false}
                            autoCapitalize={true}
                            aria-autocomplete={true}
                            rows={7}
                        />
                        <button> <h5> Send Message </h5> </button>
                    </motion.div>

                    <img
                        src="/assets/images/hero-wave.png"
                        alt=""
                        aria-hidden="true"
                        className={Classes.authBg}
                        draggable={false}
                        loading="eager"
                        decoding="async"
                        fetchPriority="high"
                    />
                </div>
            </div>
            <Footer />
        </>
    );
}
